import React, { Component } from "react";
import Field from "../Common/Field";
import { withFormik } from "formik";
import * as Yup from "yup";
import logo from "../assets/img/logo.jpg";
import { Link } from "react-router-dom";
import Axios from "axios";

const fields = [
  {
    label: "FirstName :",
    name: "FirstName",
    elementName: "input",
    type: "text",
    placeholder: "Enter your First Name",
  },
  {
    label: "LastName :",
    name: "LastName",
    elementName: "input",
    type: "text",
    placeholder: "Enter your Last Name",
  },
  {
    label: "CNIC :",
    name: "CNIC",
    elementName: "input",
    type: "tel",
    placeholder: "Your CNIC: 1310133049545",
    max: "13",
    min: "13",
  },
  {
    label: "Phone_no :",
    name: "Phno",
    elementName: "input",
    type: "tel",
    placeholder: "Phone no: 0923354563322",
    max: "13",
    min: "13",
  },
  {
    label: "Email :",
    name: "email",
    elementName: "input",
    type: "email",
    placeholder: "Your email",
  },
  {
    label: "Password :",
    name: "password",
    elementName: "input",
    type: "password",
    placeholder: "Your Password",
  },
  {
    label: "Confirm Password :",
    name: "confirmpassword",
    elementName: "input",
    type: "password",
    placeholder: "Confirm Password",
  },
  {
    label: "Date of Birth :",
    name: "DOB",
    elementName: "input",
    type: "date",
    placeholder: "Your Date of Birth",
  },
];

class Signup extends Component {
  render() {
    return (
      <div className="login-page" id="login">
        <div className="container">
          <div className="login-form">
            <Link to="/">
              {" "}
              <img
                src={logo}
                style={{
                  width: "10rem",
                  height: "3.5rem",
                  borderRadius: "1rem",
                }}
                alt="..."
              />
            </Link>
            <div className="row">
              <h1>Sign Up</h1>
            </div>
            <div className="row">
              <form onSubmit={this.props.handleSubmit}>
                {fields.map((f, i) => {
                  return (
                    <div className="col-md-12">
                      <Field
                        key={i}
                        {...f}
                        value={this.props.values[f.name]}
                        name={f.name}
                        onChange={this.props.handleChange}
                        onBlur={this.props.handleBlur}
                        touched={this.props.touched[f.name]}
                        errors={this.props.errors[f.name]}
                      />
                    </div>
                  );
                })}
                <label>
                  {" "}
                  Select Gender: <br></br>{" "}
                  <input
                    type="radio"
                    name="gender"
                    value="male"
                    id="male"
                    required
                    onChange={this.props.handleChange}
                  />{" "}
                  Male <br></br>
                  <input
                    id="female"
                    value="female"
                    name="gender"
                    type="radio"
                    required
                    onChange={this.props.handleChange}
                  />{" "}
                  Female <br></br>
                  <input
                    type="radio"
                    name="gender"
                    value="Other"
                    id="other"
                    required
                    onChange={this.props.handleChange}
                  />{" "}
                  Other <br></br>
                </label>
                <br></br>
                <br></br>
                <label name="role">
                  Select Role : <br></br>
                  <input
                    type="radio"
                    id="voter"
                    value="voter"
                    name="role"
                    required
                    onChange={this.props.handleChange}
                  />{" "}
                  Voter <br></br>
                  <input
                    type="radio"
                    id="candidate"
                    value="candidate"
                    name="role"
                    required
                    onChange={this.props.handleChange}
                  />{" "}
                  Candidate
                </label>
                <br></br>
                <br></br>
                <label>Select your Society :</label>{" "}
                <select
                  name="society"
                  id="society"
                  required
                  onChange={this.props.handleChange}
                >
                  <option value="">--Select--</option>
                  <option value="1">Select1</option>
                  <option value="2">Select2</option>
                  <option value="3">Select3</option>
                </select>
                <br></br>
                {
                  // Submit Button Below
                }
                <br></br>
                <div className="col-md-12">
                  <span>I Agree with Terms and Conditions of SEVCS</span>
                  <br></br>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    //  onClick={addUser}
                  >
                    Signup
                  </button>
                  <h6 style={{ textAlign: "right" }}>Already Registered: </h6>
                  <Link to="/login">
                    {" "}
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ float: "right" }}
                    >
                      Sign In
                    </button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withFormik({
  // Validations here..!
  mapPropsToValues: () => ({
    FirstName: "",
    LastName: "",
    Phno: "",
    DOB: "",
    CNIC: "",
    email: "",
    password: "",
    confirmpassword: "",
    role: "",
    society: "",
  }),
  validationSchema: Yup.object().shape({
    FirstName: Yup.string()
      .required("You need to enter your First Name.")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .min(3, "Name must not be less than 3 characters")
      .max(25, "Greater than 25 Characters not allowed"),
    LastName: Yup.string()
      .required("You need to enter your Last Name.")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .min(3, "Name must not be less than 3 characters")
      .max(25, "Greater than 25 Characters not allowed"),
    Phno: Yup.string()
      .required("You need to enter your Phone no..")
      .max(13, "Enter a 13 Digits Number, not more!")
      .min(13, "Enter a 13 Digits Number, not less! ")
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone no. is not Valid"
      ),
    CNIC: Yup.string()
      .required("You need to enter your CNIC.")
      .max(13, "Enter a 13 Digits CNIC, not more!")
      .min(13, "Enter a 13 Digits CNIC, not less! ")
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "CNIC is not Valid"
      ),
    email: Yup.string()

      .email("Email is invalid.")
      .required("You need to login with email address."),
    password: Yup.string()
      .required("You need to enter your password.")
      .min(8, "Minimum 8 characters allowed")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        "Must Contain One Uppercase, One Lowercase, One Number and one special case Character"
      ),
    DOB: Yup.date()
      .required("You must Enter your Date of Birth")
      .test("age", "You must be 18 or older", function (birthdate) {
        const cutoff = new Date();
        cutoff.setFullYear(cutoff.getFullYear() - 18);
        return birthdate <= cutoff;
      }),
    confirmpassword: Yup.string()
      .required("You need to enter your password.")
      .min(8, "Minimum 8 characters allowed")
      .test("pass-match", "Passwords don't match", function (value) {
        const { password } = this.parent;
        return password === value;
      }),
    //  role: Yup.required("A radio option is required"),
    // society: Yup.required("Please Specify any one"),
  }),

  handleSubmit: (values, { setSubmitting }, register) => {
    // alert("Login Success", values);

    //  console.log("All O.K", values);
    Axios.post("http://localhost:3001/create", values).then(() => {
      console.log("successfully Signed Up");
      alert("sign up successful");
    });
  },
})(Signup);
